import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import './DuplicateRequestModal.css';

function buildRequestLink(existingRequest) {
  const base =
    existingRequest.fnmaRequestStatus === 'Requested'
      ? `/lender-project-request/${existingRequest.projectId}`
      : `/project/${existingRequest.projectId}`;
  return `${base}#requestFeed`;
}

const DuplicateRequestModal = ({ show, blocking, existingRequest, requestTypeName: requestTypeNameProp, onCancel, onProceed }) => {
  const [notDuplicateChecked, setNotDuplicateChecked] = useState(false);

  useEffect(() => {
    if (show) {
      setNotDuplicateChecked(false);
    }
  }, [show]);

  if (!existingRequest) return null;

  const requestLink = buildRequestLink(existingRequest);
  const requestTypeName = requestTypeNameProp || existingRequest.requestTypeName || null;

  return (
    <Modal show={show} className="duplicate-request-modal" onHide={onCancel} backdrop="static" size="lg" centered>
      <Modal.Header className="duplicate-request-modal-header" closeButton>
        <Modal.Title className="duplicate-request-modal-title">
          {blocking ? 'Active Request Found' : 'Active Request Warning'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="duplicate-request-modal-body">
        {blocking ? (
          <p>
            This request appears to be a duplicate of an existing{requestTypeName ? <> <strong>{requestTypeName}</strong></> : ''}{' '}
            submission. If you have additional information or supporting documentation related to the
            active request, please update the original request instead. Within the previous request&#39;s
            Request Feed, select <strong>Details</strong> to upload documents, or use the{' '}
            <strong>Communications</strong> section to message the Project Standards team.{' '}
            <a href={requestLink} target="_blank" rel="noopener noreferrer">View existing request</a>.
          </p>
        ) : (
          <>
            <p>
              A{requestTypeName ? <> <strong>{requestTypeName}</strong></> : ''}{' '}
              request for this project has already been submitted by your organization. Please review
              the requests in your organization&#39;s Request Queue by selecting{' '}
              <strong>Details</strong>, and confirm your request is not a duplicate before proceeding.{' '}
              <a href={requestLink} target="_blank" rel="noopener noreferrer">View existing request</a>.
            </p>
            <div className="duplicate-request-checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={notDuplicateChecked}
                  onChange={(e) => setNotDuplicateChecked(e.target.checked)}
                />{' '}
                This is not a duplicate request.
              </label>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: '#f7f7f7' }}>
        <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
        {!blocking && (
          <button
            className="btn btn-primary continue-button"
            onClick={onProceed}
            disabled={!notDuplicateChecked}
          >
            Continue
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DuplicateRequestModal;
